export const FLOAT_PATTERN = "^[-]?([1-9]{1}[0-9]{0,}(.[0-9]{0,2})?|0(.[0-9]{0,2})?|.[0-9]{1,2})$"
export const POSITIVE_FLOAT_PATTERN = "^([1-9]{1}[0-9]{0,}(.[0-9]{0,2})?|0(.[0-9]{0,2})?|.[0-9]{1,2})$"
export const POSITIVE_INT_PATTERN = "^\\d+$"
